import { motion } from "framer-motion";
import { Lock } from "lucide-react";

const links = [
  { id: "galerie", label: "La Galerie" },
  { id: "statut", label: "Mon Statut" },
];

export default function Navbar({ onNavigate, onAdmin }) {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-burgundy/10 bg-cream/80 backdrop-blur-md"
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8 lg:px-16">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 text-left"
          data-testid="nav-logo"
        >
          <img src="/logo.jpg" alt="Logo La Table de Saint-François" className="h-11 w-11 rounded-full shadow-sm ring-1 ring-burgundy/10" />
          <span className="font-serif text-lg font-bold leading-none tracking-tight text-burgundy">
            La Table
            <span className="block text-[10px] font-medium uppercase tracking-[0.25em] text-gold">
              de Saint-François
            </span>
          </span>
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => onNavigate(l.id)}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-600 transition-colors hover:text-burgundy"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            onClick={() => onNavigate("statut")}
            className="hidden rounded-full border border-burgundy/25 px-4 py-2 text-xs font-semibold text-burgundy transition-colors hover:bg-burgundy/5 sm:block"
            data-testid="nav-lookup-button"
          >
            Mon Statut
          </button>
          <button
            onClick={() => onNavigate("reservation")}
            className="rounded-full bg-burgundy px-5 py-2 text-xs font-semibold text-cream shadow-lg shadow-burgundy/25 transition-all hover:-translate-y-0.5 hover:bg-burgundy-dark"
            data-testid="nav-reserve-button"
          >
            Réserver une table
          </button>
          <button
            onClick={onAdmin}
            aria-label="Espace administrateur"
            className="rounded-full border border-stone-300 p-2 text-stone-500 transition-colors hover:border-burgundy hover:text-burgundy"
            data-testid="nav-admin-button"
          >
            <Lock className="h-4 w-4" />
          </button>
        </div>
      </div>
    </motion.header>
  );
}
